import { render, staticRenderFns } from "./bulletinList.vue?vue&type=template&id=6653a3f4"
import script from "./bulletinList.vue?vue&type=script&lang=js"
export * from "./bulletinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports